import React, { useEffect, useState } from "react";
import { BiUser } from "react-icons/bi";
import { MdOutlineLocationOn, MdOutlineModeEditOutline } from "react-icons/md";
import CommonButton from "../../../Components/global-components/CommonButton/CommonButton";
import BannerImage from "../../../Components/login-components/banner-image/BannerImage";
import BottomCard from "../../../Components/login-components/bottom-card/BottomCard";
import LogoContainer from "../../../Components/login-components/logo-container/LogoContainer";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDrawer from "../../../Components/global-components/CommonDrawer/CommonDrawer";
// import AddressInput from "./AddressInput";
import { useSelector, useDispatch } from "react-redux";
import Tab from "../../../Components/kyc-components/Tab";
import CommonDropDown from "../../../Components/global-components/CommonDropDown/CommonDropDown";
import TextInput from "../../../Components/global-components/CommonTextInput/TextInput";
// import { TextareaAutosize } from "@mui/material";
import { customerData } from "../../Redux/userData";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import MsHome from "../../../Components/Maruti-Suzuki-components/MsHome";
import { activeStepper } from "../../Redux/stepperSlice";
import {
  documentDetail,
  fileUpload,
  previewIamgeURL,
} from "../../Redux/otherDocsSlice";
import { toggleTabs } from "../../Redux/slice";
import { formValidator, gaFunction } from "../../../Router";
import { TextField } from "@mui/material";
import ErrorBottomDrawer from "../../../Components/global-components/ErrorBottomDrawer/ErrorBottomDrawer";
import { showGlobalError } from "../../Redux/globalErrorSlice";
const gender = ["Gender", "Male", "Female", "Others"];
const maritalStatus = ["Marital Status", "Single", "Married"];

const OtherDocsFetchDetailsFrame = () => {
  const {
    name,
    address,
    reduxGenderValue,
    dob: dobRedux,
    fatherName: fatherNameRedux,
    permanentAddress,
    permanentCity,
    permanentPincode,
    permanentState,
  } = useSelector((state) => state.uploadedFile.previewDocumentDetail);
  const userImage = useSelector((state) => state.CameraImage.userImage);
  const switchGendervalue = (reduxGenderValue) => {
    switch (reduxGenderValue) {
      case "M":
        return "Male";

      case "F":
        return "Female";

      case "O":
        return "Others";

      case "T":
        return "Other";

      default:
        return "";
    }
  };

  const frontFileName = useSelector(
    (state) => state.uploadedFile.documentImage.frontFile
  );

  const [openDrawer, setOpenDrawer] = useState(false);
  const [verifyDetailsMsgPopup, setVerifyDetailsMsgPopup] = useState(false);
  const [addressActive, setAddressActive] = useState(false);
  const [checkboxActive, setCheckboxActive] = useState(true);
  const [motherName, setMotherName] = useState("");
  const [error, setError] = useState("");
  const [coError, setCoError] = useState("");
  // const [isEditable, setIsEditable] = useState(false);
  // const [nameEditable, setNameEditable] = useState(true);
  const [coAddress, setCoAddress] = useState("");
  const [coState, setCoState] = useState("");
  const [coCity, setCoCity] = useState("");
  const [coPinCode, setCoPinCode] = useState("");
  const [paAddress, setPaAddress] = useState(permanentAddress || address || "");
  const [paState, setPaState] = useState(permanentState || "");
  const [paCity, setPaCity] = useState(permanentCity || "");
  const [paPinCode, setPaPinCode] = useState(permanentPincode || "");
  const [genderValue, setGenderValue] = useState(
    switchGendervalue(reduxGenderValue) || ""
  );
  const [maritalValue, setMaritalValue] = useState("");
  const [IsCheckbox, setIsCheckbox] = useState(false);
  const [localAddress, setLocalAddress] = useState(address);
  const [dob, setDob] = useState(dobRedux === "Invalid Date" || dobRedux === ""   ? "" : changedateformatRedux(dobRedux));
  const [localName, setLocalName] = useState(name);
  const [fatherName, setfatherName] = useState(
    !fatherNameRedux ? "" : fatherNameRedux
  );
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isRouteAllowed } = state || {};
  const dispatch = useDispatch();

  const AddressHandler = () => {
    setAddressActive(!addressActive);
    setCheckboxActive(!checkboxActive);
  };
  //   const panUserDetails = useSelector((state) => state.panDetails.panUserdata);

  let fieldArray = [
    { fieldLength: motherName?.trim()?.length, fieldName: "mother name" },
    { fieldLength: localName?.trim()?.length, fieldName: "Name" },
    { fieldLength: maritalValue?.trim()?.length, fieldName: "marital status" },
    { fieldLength: genderValue?.trim()?.length, fieldName: "gender" },
    { fieldLength: dob?.length, fieldName: "Date of Birth" },
    { fieldLength: paAddress?.trim()?.length, fieldName: "Address" },
    { fieldLength: fatherName?.trim()?.length, fieldName: "Father Name" },
    { fieldLength: paState?.trim()?.length, fieldName: "State" },
    { fieldLength: paCity?.trim()?.length, fieldName: "City" },
    { fieldLength: paPinCode?.trim()?.length, fieldName: "Pincode" },
  ];
  let correspondenceFieldArray = [
    {
      fieldLength: coAddress?.trim()?.length,
      fieldName: "Correspondence Address",
    },
    { fieldLength: coState?.trim()?.length, fieldName: "Correspondence State" },
    { fieldLength: coCity?.trim()?.length, fieldName: "Correspondence City" },
    {
      fieldLength: coPinCode?.trim()?.length,
      fieldName: "Correspondence Pincode",
    },
  ];
  const pinCodeValidator = (value) => {
    let pinCodeRegex = /^[0-9\b]+$/;
    if (pinCodeRegex.test(value)) {
      setCoPinCode(value);
    }
    if (!pinCodeRegex.test(value)) {
      setCoPinCode("");
    }
  };
  const pApinCodeValidator = (value) => {
    let pinCodeRegex = /^[0-9\b]+$/;
    if (pinCodeRegex.test(value)) {
      setPaPinCode(value);
    }
    if (!pinCodeRegex.test(value)) {
      setPaPinCode("");
    }
  };

  //todo : remove comment after testing
  useEffect(() => {
    setTimeout(() => {
      setOpenDrawer(true);
    }, 1000);
  }, []);

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  const yesHandler = () => {
    setOpenDrawer(false);
    // setVerifyDetailsMsgPopup(true);
  };

  const noHandler = () => {
    navigate("/kyc");
    dispatch(fileUpload({ backFile: "", frontFile: "" }));
    dispatch(previewIamgeURL({ backImageURL: "", frontImageURL: "" }));

    // dispatch(toggleTabs("otherDocs"));
  };

  const nameEditingHandler = (e) => {
    function cleanEnglishInput(text) {
      const unicodeMap = {
        '𝐀': 'A','𝐁': 'B','𝐂': 'C','𝐃': 'D','𝐄': 'E','𝐅': 'F','𝐆': 'G','𝐇': 'H','𝐈': 'I','𝐉': 'J','𝐊': 'K','𝐋': 'L','𝐌': 'M','𝐍': 'N','𝐎': 'O','𝐏': 'P','𝐐': 'Q','𝐑': 'R','𝐒': 'S','𝐓': 'T','𝐔': 'U','𝐕': 'V','𝐖': 'W','𝐗': 'X','𝐘': 'Y','𝐙': 'Z',
        '𝐚': 'a','𝐛': 'b','𝐜': 'c','𝐝': 'd','𝐞': 'e','𝐟': 'f','𝐠': 'g','𝐡': 'h','𝐢': 'i','𝐣': 'j','𝐤': 'k','𝐥': 'l','𝐦': 'm','𝐧': 'n','𝐨': 'o','𝐩': 'p','𝐪': 'q','𝐫': 'r','𝐬': 's','𝐭': 't','𝐮': 'u','𝐯': 'v','𝐰': 'w','𝐱': 'x','𝐲': 'y','𝐳': 'z'
      };
    
     // Step 1: Trim whitespace
  let cleaned=text

  // Step 2: Normalize stylized Unicode English letters
  cleaned = cleaned.replace(/[\uD835][\uDC00-\uDCFF]/g, (match) => {
    return unicodeMap[match] || '';
  });

  // Step 3: Remove unwanted characters but keep spaces
  cleaned = cleaned.replace(/[^A-Za-z ]/g, '');

  return cleaned
    }
    
  setLocalName(cleanEnglishInput(e.target.value))
  };

  // const backHandler = () => {
  //   navigate("/kyc");
  // };
  //webcam
  const checkBoxHandler = () => {
    setIsCheckbox((prev) => !prev);
  };
  function changedateformat(val) {
    const myArray = val.split("-");
    let year = myArray[0];
    let month = myArray[1];
    let day = myArray[2];
    let formatteddate = day + "-" + month + "-" + year;
    return formatteddate;
  }
  function changedateformatRedux(val) {
    const myArray = val.split("/");
    let year = myArray[2];
    let month = myArray[1];
    let day = myArray[0];
    let formatteddate = year + "-" + month + "-" + day;
    return formatteddate;
  }
  const continueHandler = () => {
    const emptyFieldName = formValidator(fieldArray);
    const coEmptyFieldName = formValidator(correspondenceFieldArray);
    if (emptyFieldName) {
      setError("Please provide all details : " + emptyFieldName);
      dispatch(showGlobalError("Please fill this detail : " + emptyFieldName));
      return;
    }
    if (!checkboxActive && coEmptyFieldName) {
      setCoError("Please fill this detail : " + coEmptyFieldName);
      dispatch(
        showGlobalError("Please fill this detail : " + coEmptyFieldName)
      );
      return;
    }

    gaFunction("OVD", "OVD Continue Clicked");
    let isInIf = false;
    if (
      checkboxActive &&
      motherName?.length !== 0 &&
      genderValue !== "" &&
      maritalValue !== "" &&
      dob !== "Invalid Date" &&
      dob !== "" &&
      fatherName !== "" &&
      paAddress?.length !== 0 &&
      paState?.length !== 0 &&
      paCity?.length !== 0 &&
      paPinCode?.length !== 0
    ) {
      isInIf = true;

      if (!userImage) {
        navigate("/webcam", {
          state: {
            isRouteAllowed: true,
            type: "ovd",
          },
        });
      }
      if (userImage) {
        navigate("/image", {
          state: {
            isRouteAllowed: true,
            type: "ovd",
          },
        });
      }
      // navigate(userImage !== "" ? "/image" : "/webcam", {
      //   state: {
      //     isRouteAllowed: true,
      //     type: "ovd",
      //   },
      // });
      dispatch(
        customerData({
          gender: genderValue,
          maritalStatus: maritalValue,
          mothersName: motherName,
          correspondenceAddress: coAddress,
          correspondenceState: coState,
          correspondenceCity: coCity,
          correspondencePincode: coPinCode,
          permanentAddress: paAddress,
          permanentState: paState,
          permanentCity: paCity,
          permanentPincode: paPinCode,
          userEditedAddress:
            paAddress !== permanentAddress ||
            paCity !== permanentCity ||
            paState !== permanentState ||
            paPinCode !== permanentPincode,
          userEditedName: name !== localName,
          name: name === localName ? name : localName,
      manualKYC: dobRedux === "Invalid Date" || dobRedux === "" || changedateformatRedux(dobRedux)!==dob || paPinCode !== permanentPincode ,
      fatherName,
        })
      );

      dispatch(activeStepper(3));

        dispatch(
          documentDetail({
            dob: changedateformat(dob),
            fatherName
          })
        );
    } else {
      setError("Please provide all details");
    }
    if (
      !checkboxActive &&
      coAddress?.length > 0 &&
      coAddress?.length > 0 &&
      coState?.length > 0 &&
      coCity?.length > 0 &&
      paAddress?.length !== 0 &&
      paState?.length !== 0 &&
      paCity?.length !== 0 &&
      paPinCode?.length !== 0 &&
      coPinCode?.length > 0 &&
      motherName?.length !== 0 &&
      genderValue !== "" &&
      maritalValue !== "" &&
      IsCheckbox &&
      dob !== "Invalid Date" &&
      dob !== "" &&
      fatherName !== ""
    ) {
      isInIf = true;
      navigate(userImage ? "/image" : "/webcam", {
        state: {
          isRouteAllowed: true,
          type: "ovd",
        },
      });
      dispatch(
        customerData({
          gender: genderValue,
          maritalStatus: maritalValue,
          mothersName: motherName,
          correspondenceAddress: coAddress,
          correspondenceState: coState,
          correspondenceCity: coCity,
          correspondencePincode: coPinCode,
          permanentAddress: paAddress,
          permanentState: paState,
          permanentCity: paCity,
          permanentPincode: paPinCode,
          userEditedAddress:
            paAddress !== permanentAddress ||
            paCity !== permanentCity ||
            paState !== permanentState ||
            paPinCode !== permanentPincode,
          userEditedName: name !== localName,
          name: name === localName ? name : localName,
      manualKYC: dobRedux === "Invalid Date" || dobRedux === "" || changedateformatRedux(dobRedux)!==dob || paPinCode !== permanentPincode ,
          fatherName,
        })
      );
      dispatch(activeStepper(2));
        dispatch(
          documentDetail({
            dob: changedateformat(dob),
            fatherName,
          })
        );

    } else {
      setError("Please provide all details");
    }
    if (!isInIf) {
      alert("Please fill all fields");
    }
  };
  // const editHandler = () => {
  //   setIsEditable((prev) => !prev);
  // };
  // const nameEditHandler = () => {
  //   setNameEditable((prev) => !prev);
  // };
  useEffect(() => {
    // disable browser button
    return () => {
      setTimeout(() => {
        window.history.forward();
      }, 0);
    };
  }, []);

  useEffect(() => {
    if (!state) navigate("/");
  }, [navigate, state]);

  useEffect(() => {
    if (!frontFileName?.length) navigate("/kyc");
  }, [frontFileName?.length]);

  return (
    <>
      {isRouteAllowed && (
        <div className="flex flex-col h-full">
          <MsHome>
            <BannerImage>
              {/* <CommonTopBackButton backHandler={backHandler} /> */}
              <LogoContainer />
            </BannerImage>

            <div className="bg-[#fce9e9] h-full">
              <BottomCard>
                <div className="h-max w-full z-0 last:mb-[15vh] md:mb-0 md:h-full">
                  {/* <div className="md:flex justify-around"> */}
                  <div className="hidden md:block md:h-[30%]">
                    <div className="p-[10px] md:p-0"></div>
                    <label className="md:text-xl">
                      <b>KYC Document</b>
                    </label>
                    <p className="hidden md:block md:text-sm">
                      let's fetch your kyc details using
                    </p>
                    <div className="p-[10px] md:p-[7px]"></div>
                    <div className="md:w-[50%] md:mb-5">
                      <Tab isDisabled />
                    </div>
                  </div>
                  <div className="md:w-[70%] md:h-[52%] md:block overflow-scroll  md:p-0">
                    <label>
                      <b>Name</b>
                    </label>
                    <div className="flex  p-2  w-full">
                      <div className="px-4 flex items-center">
                        <BiUser size={25} />
                      </div>
                      <div className="w-full">
                        <TextInput
                          editIcon={true}
                          value={localName}
                          onChange={nameEditingHandler}
                          width="md:w-[100%]"
                          showInput={false}
                          disableCopyPaste={true}
                          onBlur={()=>setLocalName(localName.trim())}
                        />
                      </div>
                    </div>
                    <label>
                      <b>Permanent Address</b>
                    </label>
                    <div className="flex flex-row  p-2">
                      <div className="flex flex-col px-4">
                        <MdOutlineLocationOn size={25} />
                      </div>
                      <div className="flex justify-between gap-2 w-full">
                        {/* <textarea
                          // cols={30}
                          className="min-h-max min-w-max resize-none"
                          onChange={(e) => setLocalAddress(e.target.value)}
                        >
                          {address || "NA"}
                        </textarea> */}
                        <div className="main_address_container w-full">
                          <div>
                            <TextInput
                              label={"Address"}
                              editIcon
                              id="pa_address"
                              placeholder={"ex. House no, Flat no, ABC apt"}
                              onChange={(e) => setPaAddress(e.target.value)}
                              value={paAddress}
                              showInput={false}
                            />
                          </div>
                          <div className="md:flex md:flex-row block justify-between items-center gap-5">
                            <TextInput
                              label={"State"}
                              editIcon
                              id="pa_state"
                              onChange={(e) => setPaState(e.target.value)}
                              value={paState}
                              placeholder="ex. Maharashtra"
                            />
                            <TextInput
                              label={"City"}
                              editIcon
                              id="pa_city"
                              onChange={(e) => setPaCity(e.target.value)}
                              value={paCity}
                              placeholder="ex. Pune"
                            />
                          </div>
                          <div className="pincode ">
                            <TextInput
                              type="tel"
                              editIcon
                              id="pa_number"
                              maxlen={"6"}
                              label={"PinCode"}
                              placeholder={"ex.  400001"}
                              onChange={(e) =>
                                pApinCodeValidator(e.target.value)
                              }
                              value={paPinCode}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-5">
                      <CommonDropDown
                        options={gender}
                        selected={genderValue}
                        label="Gender"
                        setSelected={setGenderValue}
                      />
                      <CommonDropDown
                        options={maritalStatus}
                        label="Marital Status"
                        selected={maritalValue}
                        setSelected={setMaritalValue}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="font-bold">Mother Name</label>
                      <TextInput
                        placeholder="Mother Name"
                        value={motherName}
                        onChange={(e) => setMotherName(e.target.value)}
                        width="md:w-[291px]"
                      />
                        <div className="mt-2">
                          <label className="font-bold">Date of birth</label>
                          <TextInput
                            placeholderUpperCase="uppercase"
                            type="date"
                            placeholder="MM/DD/YYYY"
                            value={dob}
                            onChange={(e) => setDob(e.target.value)}
                            width="md:w-[291px]"
                          />
                        </div>
                        <div className="mt-2">
                          <label className="font-bold">Father Name</label>
                          <TextInput
                            type="text"
                            placeholder="Father Name"
                            value={fatherName}
                            onChange={(e) => setfatherName(e.target.value)}
                            width="md:w-[291px]"
                          />
                        </div>
                      <p className="text-red-500 text-sm">{error}</p>
                    </div>
                    {/* <div className="flex gap-2 mb-2">
                      <ErrorOutlineIcon
                        className="text-primaryH"
                        fontSize="small"
                      />
                      <p className="text-xs flex items-center text-primaryH">
                        Add Correspondence address option as requested.
                      </p>
                    </div> */}
                    <div className="flex items-center">
                      <input
                        id="link-checkbox"
                        type="checkbox"
                        value=""
                        checked={checkboxActive}
                        className="w-5 h-5  rounded border-gray-300 text-primaryH ring-0 focus:ring-0"
                        onChange={AddressHandler}
                      />
                      <label
                        htmlFor="link-checkbox"
                        className="ml-2 text-sm font-medium text-black "
                      >
                        Use this as the correspondence address
                      </label>
                    </div>
                    {addressActive && (
                      <div className="main_address_container mt-5 ">
                        <label className="font-bold">
                          Correspondence Address
                        </label>
                        <div className="text_iput">
                          <TextInput
                            label={"Address"}
                            id="correspondence_address"
                            placeholder={"ex.  House no, Flat no, ABC Apt"}
                            onChange={(e) => setCoAddress(e.target.value)}
                            value={coAddress}
                          />
                        </div>
                        <div className="flex flex-row justify-between items-center gap-5">
                          <TextInput
                            label={"State"}
                            id="correspondence_state"
                            onChange={(e) => setCoState(e.target.value)}
                            value={coState}
                            placeholder="ex. Maharashtra"
                          />
                          <TextInput
                            label={"City"}
                            id="correspondence_city"
                            onChange={(e) => setCoCity(e.target.value)}
                            value={coCity}
                            placeholder="ex. Pune"
                          />
                        </div>
                        <div className="pincode w-[47%]">
                          <TextInput
                            type="tel"
                            id="correspondence_number"
                            maxlen={"6"}
                            label={"PinCode"}
                            placeholder={"ex.  400001"}
                            onChange={(e) => pinCodeValidator(e.target.value)}
                            value={coPinCode}
                          />
                        </div>
                        <p className="text-red-500 text-sm">{coError}</p>
                        <div className="flex items-center mt-2">
                          <input
                            id="link-checkbox"
                            type="checkbox"
                            value=""
                            checked={IsCheckbox}
                            onChange={checkBoxHandler}
                            className="w-5 h-5 rounded border-gray-300 text-red-600 ring-0 focus:ring-0"
                          />
                          <label
                            htmlFor="link-checkbox"
                            className="ml-2 text-sm font-medium text-black mt-2"
                          >
                            I confirm that this address is correct as per my
                            knowledge
                          </label>
                        </div>
                      </div>
                      // <div className="mt-[21px]">
                      //   <AddressInput />
                      // </div>
                    )}
                    {openDrawer && (
                      <CommonDrawer
                        onClickHandler={closeDrawer}
                        onProceed={yesHandler}
                        onDenied={noHandler}
                      />
                    )}
                    {verifyDetailsMsgPopup && (
                      <ErrorBottomDrawer
                        info
                        errorMessage="Kindly verify your details carefully."
                        onClickHandler={() => setVerifyDetailsMsgPopup(false)}
                      />
                    )}
                  </div>
                  <div className=" md:w-[235px] hidden md:block md:mr-auto ">
                    <CommonButton
                      arrow
                      label="Continue"
                      filled
                      onClickHandler={continueHandler}
                      id="other-details-continue-button"
                    />
                    {/* <CommonButton label="Use Another Address" location /> */}
                  </div>
                  {/* </div> */}
                </div>
              </BottomCard>
            </div>

            <BottomButtons continueHandler={continueHandler} />

            {/* <div className="fixed bottom-0 p-4 w-full bg-white rounded-sm border shadow-[2px_-4px_16px_-10px_rgba(0,0,0,0.75)] z-10 space-y-3">
        <CommonButton
          label="Continue"
          arrow
          filled
          onClickHandler={continueHandler}
        />
        <CommonButton label="Use Another Address" location />
      </div> */}
          </MsHome>
        </div>
      )}
    </>
  );
};

export default OtherDocsFetchDetailsFrame;

function BottomButtons({ continueHandler }) {
  return (
    <div className="fixed bottom-0 short:p-2 p-4 w-full bg-white rounded-sm border shadow-[2px_-4px_16px_-10px_rgba(0,0,0,0.75)] z-10 space-y-3 md:hidden">
      <CommonButton
        label="Continue"
        arrow
        filled
        onClickHandler={continueHandler}
      />
      {/* <CommonButton label="Use Another Address" location /> */}
    </div>
  );
}
